<template>
  <div>
    <v-list-tile :key="survey.id" @click="goToShowSurvey">
      <v-flex>
        <v-list-tile>
          <p class="subheader" v-if="survey.survey_type === 'survey'">
            ENCUESTA: {{survey.name.toUpperCase()}}
          </p>
          <p class="subheader" v-else>FORMULARIO: {{survey.name.toUpperCase()}}</p>
        </v-list-tile>
      </v-flex>
      <v-list-tile>
        <v-btn color="primary">Responder</v-btn>
      </v-list-tile>
    </v-list-tile>
    <v-divider></v-divider>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
export default {
  props: {
    survey: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions({
      _updateSurvey: "surveys/updateSurvey"
    }),
    ...mapMutations("surveys", ["setSurvey"]),
    goToShowSurvey() {
      this.setSurvey(this.survey);
      this.$router.push({
        name: "survey-show",
        params: { id: this.survey.id, slug: this.survey.slug }
      });
    }
  }
};
</script>